module.exports = __webpack_public_path__ + "ic_alarm-b8126a6fe90a74c2775030177726ff9c.png";